import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const CONSENT_KEY = "morellis_cookie_consent";
export const CONSENT_EVENT = "morellis-consent";
export const getConsent = () => (typeof window !== "undefined" ? localStorage.getItem(CONSENT_KEY) : null);
export const setConsent = (v) => {
  localStorage.setItem(CONSENT_KEY, v);
  window.dispatchEvent(new Event(CONSENT_EVENT));
};

const CookieConsent = () => {
  const [choice, setChoice] = useState(getConsent());

  useEffect(() => {
    const onChange = () => setChoice(getConsent());
    window.addEventListener(CONSENT_EVENT, onChange);
    return () => window.removeEventListener(CONSENT_EVENT, onChange);
  }, []);

  return (
    <AnimatePresence>
      {!choice && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-consent"
          role="dialog"
          aria-label="Cookie consent"
          className="fixed bottom-4 inset-x-4 md:left-auto md:right-8 md:max-w-md z-[60] bg-cream rounded-3xl border border-gold/40 shadow-2xl shadow-teal/20 p-6"
        >
          <p className="font-display font-bold text-lg text-teal">A quick word about cookies</p>
          <p className="mt-2 text-xs text-teal/70 leading-relaxed">
            We use a third-party map to help you find us, which may set cookies.
            Accept to load it, or reject and we&rsquo;ll simply show you the address instead.
            Read our <a href="/privacy" className="underline hover:text-gold transition-colors">privacy notice</a>.
          </p>
          <div className="mt-4 flex gap-3">
            <button onClick={() => setConsent("accepted")} data-testid="cookie-accept"
              className="flex-1 rounded-full bg-teal text-cream text-xs uppercase tracking-[0.2em] font-semibold py-3 hover:bg-gold hover:text-teal-deep transition-colors duration-300 active:scale-95">
              Accept
            </button>
            <button onClick={() => setConsent("rejected")} data-testid="cookie-reject"
              className="flex-1 rounded-full border border-teal/30 text-teal text-xs uppercase tracking-[0.2em] py-3 hover:border-gold hover:text-gold transition-colors duration-300 active:scale-95">
              Reject
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
